import React from "react";
import { styled } from "@mui/material/styles";
import { Grid, Container, Typography } from "@mui/material";
import { useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import Seo from "../components/Seo";

// Styles for About component
const AboutContainer = styled("section")(({ theme }) => ({
  backgroundColor: theme.palette.secondary.main,
  fontFamily: theme.typography.fontFamily,
  color: theme.palette.text.light,
  fontSize: "1.5rem",
  padding: theme.spacing(1),
  textAlign: "flex-start",
}));

const Header = styled(Typography)(({ theme }) => ({
  color: theme.palette.primary.main,
  fontFamily: theme.typography.h1.fontFamily,
  fontSize: theme.typography.h1.fontSize,
  fontWeight: 700,
  textTransform: "uppercase",
}));

const GalleryImage = styled("img")(({ theme }) => ({
  width: "100%",
  height: "400px",
  objectFit: "cover",
  margin: 0,
  padding: 0,
  transition: "transform 0.4s ease-in-out",
  "&:hover": {
    transform: "scale(1.1)",
  },
}));

const About = () => {
  const { i18n, t } = useTranslation();
  const location = useLocation();
  const lang = i18n.language;

  const aboutContent = (
    <Container>
      <Header sx={{ textAlign: "center" }}>{t("menu.About")}</Header>
      <p>{t("about.about")}</p>
    </Container>
  );

  // Gallery images data
  const images = [
    "/img/gallery/1.jpeg",
    "/img/gallery/2.jpeg",
    "/img/gallery/3.jpeg",
    "/img/gallery/4.jpeg",
    "/img/gallery/5.jpeg",
    "/img/gallery/6.jpeg",
    "/img/gallery/gallery-1.jpg",
    "/img/gallery/gallery-2.jpg",
    "/img/gallery/gallery-3.jpg",
    "/img/gallery/gallery-4.jpg",
    "/img/gallery/gallery-5.jpg",
    "/img/gallery/gallery-6.jpg",
    "/img/gallery/gallery-7.jpg",
    "/img/gallery/gallery-8.jpg",
    "/img/gallery/gallery-9.jpg",
    "/img/gallery/gallery-10.jpg",
    "/img/gallery/gallery-11.jpg",
    "/img/gallery/gallery-12.jpg",
    "/img/gallery/gallery-13.jpg",
    "/img/gallery/gallery-14.jpg",
    // "/img/gallery/gallery-10.jpeg",
    // "/img/gallery/gallery-11.jpeg",
    // "/img/gallery/gallery-12.jpeg",
    // "/img/gallery/gallery-13.jpeg",
    // "/img/gallery/gallery-15.jpeg",
  ];

  return (
    <>
      <Seo
        title={t("menu.About")}
        description={t("about.about")}
        pathname={location.pathname}
        lang={lang}
      />
      <AboutContainer id="about">
        {aboutContent}
        <Grid container spacing={1}>
        {images.map((image, index) => (
          <Grid item xs={12} sm={6} md={4} key={index}>
            <GalleryImage
              src={image}
              alt={`Gallery Image ${index}`}
              // onClick={() => handleOpen(index)}
            />
          </Grid>
        ))}
      </Grid>
    </AboutContainer>
    </>
  );
};

export default About;
